import { RootState } from 'store/rootReducer';

export const accountSlice = (state: RootState) => state.features.account;

export const deleteAccountState = (state: RootState) => accountSlice(state);
